import styled from 'styled-components';

export const StyledWrapper = styled.div`
  padding: 16px;
  border-radius: 4px;
  background: #fff;
  box-shadow:
    0px 7px 7px -5px rgba(0, 0, 0, 0.04),
    0px 10px 15px -5px rgba(0, 0, 0, 0.1),
    0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  width: 390px;
  .title {
    color: #000;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 8px;
  }
  .text {
    color: #495057;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 24px;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .back {
      border: none;
      padding: 0;
      padding: 6px 12px;
      color: #25262b;
      font-size: 14px;
      line-height: 20px;
      height: 31px;
      line-height: 22px;
    }
    .buttons {
      display: flex;
      align-items: center;
      gap: 16px;
    }
  }
`;
